import { useEffect, useRef } from "react";

/**
 * Returns true when a tracked value changes during a pending transition.
 *
 * Useful for distinguishing which URL param triggered a transition —
 * e.g. pulse stat cards only when the view changes, not on every filter click.
 */
export function useTransitioningValue<T>(
  value: T,
  isPending: boolean,
): boolean {
  const previousValue = useRef(value);
  const isTransitioning = isPending && previousValue.current !== value;

  useEffect(function syncAfterTransition() {
    if (!isPending) {
      previousValue.current = value;
    }
  }, [isPending, value]);

  return isTransitioning;
}
